{
  "languages": {
    "en": "영어",
    "ko": "한국어",
    "zh-cn": "중국어 간체",
    "zh-tw": "중국어 번체",
    "ja": "일본어",
    "es": "스페인어",
    "fr": "프랑스어",
    "vi": "베트남어",
    "id": "인도네시아어",
    "th": "태국어",
    "ru": "러시아어",
    "de": "독일어",
    "pt": "포르투갈어"
  },
  "countries": {
    "us": "미국",
    "gb": "영국",
    "au": "호주",
    "ca": "캐나다",
    "sg": "싱가포르",
    "in": "인도",
    "es": "스페인",
    "mx": "멕시코",
    "ar": "아르헨티나",
    "cl": "칠레",
    "co": "콜롬비아",
    "pe": "페루",
    "pt": "포르투갈",
    "br": "브라질",
    "kr": "대한민국",
    "vn": "베트남",
    "jp": "일본",
    "cn": "중국",
    "tw": "대만",
    "ru": "러시아",
    "th": "태국",
    "id": "인도네시아",
    "fr": "프랑스",
    "de": "독일",
    "xx": "무국적"
  },
  "onboarding": {
    "greeting": "안녕하세요! 저는 MooWoo예요.",
    "question": "어떤 언어를 사용하세요?",
    "select": "언어를 선택하세요",
    "search": "언어 검색...",
    "continue": "계속하기",
    "skip": "건너뛰기",
    "no_languages": "언어를 찾을 수 없습니다"
  },
  "auth": {
    "title": "MooWoo에 오신 걸 환영해요",
    "subtitle": "이메일을 입력해 시작하세요",
    "email_placeholder": "you@example.com",
    "send_code": "인증 코드 보내기",
    "sending": "전송 중...",
    "code_placeholder": "6자리 코드를 입력하세요",
    "code_sent": "{{email}} 주소로 코드를 보냈어요",
    "code_sent_check_spam": "메일이 도착하지 않았나요? 스팸함이나 프로모션 탭도 확인해 주세요.",
    "verify": "인증하고 계속하기",
    "verifying": "인증 중...",
    "resend": "코드 다시 보내기",
    "resend_wait": "재발송 대기 ({{seconds}}초)",
    "change_email": "다른 이메일 사용하기",
    "error_invalid_email": "올바른 이메일 주소를 입력해 주세요.",
    "error_invalid_code": "코드가 올바르지 않거나 만료되었습니다. 다시 시도해 주세요.",
    "error_code_incomplete": "인증번호 6자리를 모두 입력해 주세요.",
    "error_cooldown_wait": "잠시 후 다시 시도해 주세요.",
    "error_deletion_cooldown": "탈퇴한 계정입니다. 같은 이메일은 탈퇴일로부터 1년 뒤에 다시 가입할 수 있어요.",
    "error_generic": "문제가 발생했습니다. 다시 시도해 주세요.",
    "google_login_failed": "구글 로그인에 실패했습니다. 다시 시도해 주세요.",
    "google_login_cancelled": "구글 로그인이 취소되었습니다.",
    "google_login_error": "구글 로그인 중 오류가 발생했습니다. 다시 시도해 주세요.",
    "inapp_browser_google_restriction": "현재 앱 내부에서는 구글 로그인이 지원되지 않습니다. 이메일로 계속하시거나, 메뉴에서 Chrome·Safari 등 외부 브라우저로 열어주세요.",
    "inapp_google_desc": "현재 앱 안에서는 구글 로그인을 이용할 수 없어요.",
    "open_in_browser": "브라우저로 열기",
    "copy_link": "주소 복사",
    "copy_link_copied": "복사 완료!",
    "inapp_ios_guide": "화면의 메뉴에서 'Safari로 열기' 또는 '다른 브라우저로 열기'를 눌러주세요. 또는 아래 주소를 복사해 Safari에 붙여넣어도 됩니다.",
    "force_google_login": "그래도 구글 로그인 시도",
    "copy_manual_guide": "아래 주소를 복사하여 브라우저에 붙여넣어 주세요:",
    "inapp_open_failed": "브라우저가 열리지 않았어요. 아래 주소를 복사해 브라우저에서 열어주세요.",
    "inapp_use_browser": "구글 로그인은 브라우저에서만 가능해요.",
    "inapp_generic_guide": "화면의 메뉴에서 '브라우저로 열기'를 선택하거나, 아래 주소를 복사해 브라우저에서 열어주세요.",
    "redirecting": "이동 중..."
  },
  "chat_list": {
    "title": "채팅 멤버",
    "empty_title": "아직 대화가 없어요",
    "empty_subtitle": "어떤 언어로든 새 대화를 시작해 보세요",
    "start_new_chat": "새 대화 시작하기",
    "date_format": "{{month}}월 {{day}}일",
    "date_today": "오늘",
    "date_yesterday": "어제",
    "menu_block_delete": "차단/삭제",
    "menu_manage_blocked": "차단된 친구 관리",
    "menu_manage_deleted": "삭제된 친구 관리",
    "toast_deleted": "대화 목록에서 삭제했어요",
    "error_delete": "삭제 처리 중 오류가 발생했습니다. 다시 시도해 주세요.",
    "toast_blocked": "친구를 차단했어요",
    "error_block": "차단 처리 중 오류가 발생했습니다. 다시 시도해 주세요.",
    "manage_aria": "채팅방 관리",
    "search_placeholder": "채팅 검색...",
    "loading": "목록을 불러오는 중...",
    "selected_count": "{{count}}개 선택됨",
    "action_block": "차단",
    "blocked_badge": "차단됨",
    "action_delete": "삭제",
    "fab_new_chat": "새 대화",
    "cancel": "취소",
    "delete_sheet_title": "삭제",
    "delete_sheet_desc1": "선택한 {{count}}명을 삭제할까요?",
    "delete_sheet_desc2": "내 대화 목록과 친구 목록에서 삭제됩니다.",
    "delete_sheet_desc3": "상대방에게는 삭제되지 않습니다 / 삭제된 친구 관리에서 복원할 수 있습니다",
    "block_sheet_title": "친구 차단",
    "block_sheet_desc1": "선택한 {{count}}명을 차단할까요?",
    "block_sheet_desc2": "차단 목록으로 이동하며 언제든 해제할 수 있어요.",
    "block_sheet_desc3": "상대방은 차단된 사실을 알 수 없습니다",
    "unknown_partner": "대화 상대",
    "group_chat_default_name": "단체 대화방",
    "fab_menu_invite": "새 친구 초대",
    "find_friend_by_email": "이메일로 친구 찾기",
    "fab_menu_group": "단체 대화방 만들기",
    "invited_badge": "초대",
    "tab_group": "단체",
    "toast_current_direct": "지금은 1:1 대화방 목록입니다",
    "toast_current_group": "지금은 단체방 목록입니다"
  },
  "group_chat": {
    "title": "대화 상대 선택",
    "header_default_name": "단체 대화방",
    "inviting": "초대중",
    "invite_sheet_title": "단체 대화방 초대",
    "invite_sheet_desc": "대화방 초대를 수락하시겠습니까?",
    "accept": "수락",
    "reject": "거절",
    "invite_rejected_toast": "대화방 초대를 거절했습니다.",
    "invite_error": "초대 처리 중 오류가 발생했습니다.",
    "search_placeholder": "이름 또는 별칭으로 검색",
    "start_button": "대화 시작 ({{count}}명)",
    "max_members_toast": "단체 대화방은 최대 10명까지 참여할 수 있습니다.",
    "empty_candidates": "초대 가능한 대화 상대가 없습니다.",
    "empty_search": "검색 결과가 없습니다.",
    "sheet_title": "대화방 이름 설정",
    "sheet_placeholder": "대화방 이름을 입력하세요",
    "sheet_guide": "비워두면 참여자 이름으로 자동 설정됩니다.",
    "sheet_cancel": "취소",
    "sheet_confirm": "확인",
    "creating": "생성 중...",
    "err_too_few": "단체 대화방은 최소 3명 이상(본인 포함)이어야 합니다.",
    "menu_leave": "나가기",
    "action_leave": "나가기",
    "pending_cannot_leave": "아직 참여하지 않은 초대예요. 방에 들어가 초대를 거절하면 목록에서 사라집니다.",
    "leave_sheet_title": "대화방 나가기",
    "leave_sheet_desc1": "선택한 {{count}}개의 대화방에서 나갈까요?",
    "leave_sheet_desc2": "나간 대화방의 메시지는 다시 볼 수 없습니다.",
    "toast_leave_success": "{{count}}개의 대화방에서 나갔습니다.",
    "toast_leave_partial": "{{successCount}}개 완료, {{failCount}}개 나가기 실패했습니다.",
    "toast_leave_fail": "대화방 나가기에 실패했습니다. 다시 시도해 주세요.",
    "notif_invite_rejected_single": "{{name}}님이 초대를 거절했습니다",
    "notif_invite_rejected_multi": "{{name}}님 외 {{count}}명이 초대를 거절했습니다",
    "notif_invite_rejected_none": "초대가 거절되었습니다",
    "notif_invite_accepted_single": "{{name}}님이 참여했습니다",
    "notif_invite_accepted_multi": "{{name}}님 외 {{count}}명이 참여했습니다",
    "notif_invite_accepted_none": "초대가 수락되었습니다",
    "ad_planned": "광고 기획 중",
    "err_too_many": "단체 대화방은 최대 10명까지 가능합니다.",
    "err_no_history": "1:1 대화 이력이 없는 상대는 초대할 수 없습니다.",
    "err_unauthenticated": "로그인이 필요합니다.",
    "err_unknown": "대화방 생성 중 오류가 발생했습니다. 다시 시도해 주세요."
  },
  "setup_profile": {
    "title": "프로필 설정",
    "subtitle": "대화방에서 사용할 이름을 입력해 주세요.",
    "name_label": "이름",
    "name_required": "필수",
    "name_placeholder": "이름을 입력해 주세요",
    "complete": "완료",
    "saving": "저장 중...",
    "error_empty": "이름을 입력해 주셔야 해요",
    "error_generic": "저장에 실패했습니다. 다시 시도해 주세요."
  },
  "contacts": {
    "title": "친구",
    "empty_title": "아직 친구가 없어요.",
    "empty_desc": "친구(즐겨찾기)로 추가한 사람이 여기에 표시됩니다.",
    "loading": "불러오는 중...",
    "toast_deleted": "친구 목록에서 삭제했어요",
    "toast_blocked": "친구를 차단했어요",
    "toast_hard_deleted": "선택한 친구를 완전히 삭제했어요",
    "manage_friends": "친구 관리",
    "error_open_chat": "채팅방을 열 수 없어요",
    "selected_count": "{{count}}개 선택됨",
    "action_delete": "친구 해제",
    "action_block": "차단",
    "action_hard_delete": "삭제",
    "cancel": "취소",
    "block_sheet_title": "친구 차단",
    "block_sheet_desc1": "선택한 {{count}}명을 차단할까요?",
    "block_sheet_desc2": "차단 목록으로 이동하며 언제든 해제할 수 있어요.",
    "block_sheet_desc3": "상대방은 차단된 사실을 알 수 없습니다",
    "delete_sheet_title": "삭제",
    "delete_sheet_desc1": "선택한 {{count}}명을 삭제할까요?",
    "delete_sheet_desc2": "내 대화 목록과 친구 목록에서 삭제됩니다.",
    "delete_sheet_desc3": "(상대방에게는 삭제되지 않습니다 / 삭제된 친구 관리에서 복원할 수 있습니다)",
    "find_friend_title": "친구 찾기",
    "find_friend_desc": "이메일로 친구를 찾아보세요"
  },
  "find_friend": {
    "title": "친구 찾기",
    "placeholder": "이메일 주소를 입력하세요",
    "hint": "친구의 이메일 주소로 검색할 수 있어요",
    "invalid_email": "올바른 이메일 형식이 아니에요",
    "searching": "찾는 중...",
    "no_result": "일치하는 사용자를 찾을 수 없어요",
    "no_result_hint": "이메일 주소를 다시 확인해 주세요",
    "error": "검색에 실패했어요. 잠시 후 다시 시도해 주세요",
    "error_rate_limit": "검색 횟수가 많아요. 잠시 후 다시 시도해 주세요",
    "rel_self": "나",
    "rel_friend": "친구",
    "rel_requested": "요청함",
    "rel_received": "요청받음",
    "rel_add": "친구 요청",
    "request_sent": "친구 요청을 보냈어요",
    "auto_accepted": "친구가 되었어요",
    "cooldown_soon": "잠시 후 다시 요청할 수 있어요",
    "cooldown_minutes": "{{minutes}}분 후에 다시 요청할 수 있어요",
    "cooldown_hours": "{{hours}}시간 후에 다시 요청할 수 있어요",
    "check_notification": "알림함에서 요청을 확인해 주세요",
    "toast_already_requested": "이미 친구 요청을 보냈어요. 상대가 응답하면 알림함에서 알려 드릴게요.",
    "err_already_sent": "이미 요청을 보냈어요",
    "err_already_friend": "이미 친구예요",
    "err_not_found": "사용자를 찾을 수 없어요",
    "err_cannot_self": "본인에게는 요청할 수 없어요",
    "err_send_limit": "요청을 너무 많이 보냈어요. 내일 다시 시도해 주세요",
    "err_generic": "요청에 실패했어요. 잠시 후 다시 시도해 주세요"
  },
  "nav": {
    "friends": "친구·설정",
    "home": "홈",
    "profile": "프로필"
  },
  "profile": {
    "title": "프로필",
    "my_language": "내 기본 언어",
    "lang_sheet_title": "내 언어 설정",
    "lang_sheet_desc": "기본으로 사용할 언어를 선택하세요.",
    "lang_sheet_country_title": "국가 선택",
    "lang_sheet_country_desc": "국가를 선택해주세요.",
    "name_too_long": "이름은 한글 10자(영문 20자)까지 입력할 수 있어요",
    "nickname_too_long": "닉네임은 한글 10자(영문 20자)까지 입력할 수 있어요",
    "name_required": "이름을 입력해 주세요",
    "display_name_hint": "대화 시 표시할 호칭을 선택하세요",
    "display_name": "이름",
    "display_nickname": "닉네임",
    "status_placeholder": "상태 메시지 입력",
    "private_info": "비공개 정보",
    "only_you": "나만 볼 수 있어요",
    "email_hint": "다시 로그인할 때 이 이메일 주소가 필요해요.",
    "save_changes": "변경 저장",
    "save_success_with_photo": "정보와 사진이 저장되었습니다.",
    "save_success": "저장되었습니다",
    "save_failed": "저장하지 못했습니다. 잠시 후 다시 시도해주세요.",
    "photo_too_large": "사진이 너무 큽니다. 30MB 이하로 올려주세요.",
    "photo_unsupported_format": "이 형식은 지원하지 않습니다. JPG, PNG, WebP 사진을 올려주세요.",
    "gender_male": "남성",
    "gender_female": "여성",
    "gender_none": "선택 안 함",
    "gender_hint_thai": "태국어 등 일부 언어는, 성별을 선택하시면\n더 친밀한 대화가 가능해요",
    "name_placeholder": "실명 입력",
    "nickname_placeholder": "닉네임 입력",
    "city_placeholder": "주소(도시)",
    "add_photo": "사진 추가",
    "logout_failed": "로그아웃 실패",
    "logout_confirm_title": "로그아웃할까요?",
    "logout_confirm_in_call": "진행 중인 통화도 함께 끝납니다.",
    "photo_deleted": "사진이 삭제되었습니다.",
    "uploading": "올리는 중...",
    "not_saved": "저장 전",
    "options": "옵션",
    "change_photo": "다른 사진으로 바꾸기",
    "delete_photo": "사진 삭제",
    "delete_photo_sheet_title": "사진 삭제",
    "delete_photo_sheet_desc": "이 사진을 삭제할까요?",
    "unsaved_photo_sheet_title": "저장하지 않은 사진이 있습니다",
    "unsaved_photo_sheet_desc": "나가시겠습니까? 저장하지 않은 사진은 사라집니다.",
    "install_app": "앱 설치",
    "delete_account": "계정 삭제",
    "delete_account_title": "계정을 삭제하시겠습니까?",
    "delete_account_desc": "계정을 삭제하면 되돌릴 수 없습니다.\n\n프로필, 친구 목록, 보유 중인 무우는 모두 삭제됩니다. 대화 기록은 참여자 모두가 90일간 이용하지 않으면 자동으로 삭제되며, 보낸 사람은 '알 수 없는 사용자'로 표시됩니다. 결제 내역은 법령에 따라 5년간 보관됩니다.\n\n같은 이메일로는 1년간 다시 가입할 수 없습니다.",
    "delete_account_balance_warn": "보유 중인 무우 {{count}}개가 함께 사라집니다.",
    "delete_account_confirm": "삭제",
    "delete_account_cancel": "취소",
    "delete_account_failed": "계정 삭제에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    "delete_account_success": "계정이 삭제되었습니다.",
    "install_ios_hint": "아이폰은 사파리 하단 공유 버튼을 누르고 '홈 화면에 추가'를 선택해 주세요.",
    "install_retry_hint": "지금은 설치 창을 열 수 없습니다. 화면을 새로고침한 뒤 다시 눌러 주세요.",
    "install_done": "설치 완료",
    "install_refresh": "새로고침",
    "install_success_hint": "무우 설치가 끝났어요.\n홈 화면을 눌러 위로 올리면 나오는 앱 목록에서\n무우 아이콘을 길게 눌러 홈 화면에 두세요.",
    "install_reinstall_hint": "이미 설치되어 있어요. 앱을 지우셨다면 아래 새로고침을 누른 뒤 다시 설치할 수 있어요.",
    "install_confirm": "확인",
    "install_already_hint": "무우가 이미 설치되어 있어요. 홈 화면이나 앱 목록에서 무우 아이콘을 찾아 주세요.",
    "install_unavailable_hint": "설치 창이 열리지 않으면 화면을 아래로 당겨 새로고침한 뒤, 앱 설치 버튼을 다시 눌러 주세요."
  },
  "new_chat": {
    "header": "채팅 언어 설정",
    "my_language": "내 국가 / 언어",
    "select_placeholder": "언어를 선택하세요...",
    "translation_tone": "번역 톤",
    "polite": "정중",
    "casual": "친근",
    "basic": "기본",
    "tone_hint": "정중·친근 톤은 무우가 조금 더 소모돼요.",
    "toast_tone_basic": "원문 말투를 살려\n가장 빠르게 번역해요",
    "toast_tone_polite": "매너있게 번역해요\n처음 만남에 좋아요",
    "toast_tone_casual": "가까운 친구처럼\n편하게 번역해요",
    "start_invite": "대화 시작 / 초대하기"
  },
  "chat_conversation": {
    "error_load_failed": "대화방을 불러오지 못했습니다",
    "error_no_access": "삭제되었거나 접근할 수 없는 채팅방입니다.",
    "error_blocked": "차단한 사용자와의 대화방입니다.",
    "invite_not_accepted": "초대를 먼저 수락해 주세요",
    "error_tts_unsupported": "이 브라우저는 음성 기능을 지원하지 않습니다.",
    "error_tts_no_voice": "이 기기에 '{{langName}}' 음성이 없어 재생할 수 없습니다. 시스템 설정에서 음성 팩을 설치해 주세요.",
    "error_tts_no_secondary_lang": "이 메시지의 두 번째 언어 정보를 찾을 수 없습니다.",
    "error_tts_unsupported_lang": "지원하지 않는 언어라 음성으로 읽을 수 없습니다.",
    "error_lang_save": "언어 저장 실패",
    "toast_input_lang_set": "입력 언어: {{langName}}",
    "toast_primary_lang_set": "1차 번역: {{langName}}",
    "toast_secondary_lang_set": "2차 번역: {{langName}}",
    "toast_secondary_lang_off": "2차 번역 해제",
    "toast_copied": "복사되었습니다",
    "toast_copy_failed": "복사에 실패했습니다",
    "toast_mic_hint": "키보드의 마이크를 누르면, 음성으로 입력할 수 있어요",
    "toast_mic_hint_ios_label": "마이크가 안 보이면:",
    "toast_mic_hint_ios_path": "설정 → 일반 → 키보드 → 받아쓰기 활성화",
    "error_send_failed": "메시지 전송에 실패했습니다.",
    "error_send_failed_restored": "전송에 실패했습니다. 작성한 내용을 입력창에 다시 담았습니다.",
    "translation_unavailable": "통신 장애로 번역이 잠시 지연되고 있습니다. 다시 시도해 주세요. (무우는 차감되지 않았습니다)",
    "header_loading": "불러오는 중...",
    "header_unknown_user": "알 수 없는 사용자",
    "date_today": "오늘",
    "date_yesterday": "어제",
    "loading_messages": "메시지를 불러오는 중...",
    "empty_conversation": "아직 대화가 없습니다. 인사를 건네보세요!",
    "menu_select_delete": "삭제 선택",
    "delete_for_me": "나에게만 삭제",
    "delete_for_everyone": "모두에게 삭제",
    "deleted_message": "삭제된 메시지입니다",
    "delete_cancel": "취소",
    "menu_copy": "복사",
    "menu_save": "저장",
    "toast_tone_polite": "정중하게 번역해요",
    "toast_tone_casual": "친근하게 번역해요",
    "toast_tone_basic": "기본 모드로 번역해요",
    "toast_tts_on": "새 메시지를 읽어줄게요 (소리가 안 나면 기기 볼륨 확인)",
    "toast_tts_off": "자동 읽기를 껐어요",
    "input_placeholder": "메시지 입력",
    "sheet_lang_title": "대화 상대 언어 1",
    "sheet_lang_desc": "이 대화방에 적용할 첫번째 언어를 선택하세요.",
    "sheet_input_lang_title": "내 입력 언어",
    "sheet_input_lang_desc": "메시지를 작성할 언어를 선택하세요.",
    "sheet_lang2_title": "대화 상대 언어 2 (선택)",
    "sheet_lang2_desc": "필요하실 경우 대화방에 적용할 두번째 언어를 선택하세요.",
    "feature_coming_soon": "준비 중인 기능입니다.",
    "error_file_too_large": "파일 크기가 30MB를 초과하여 첨부할 수 없습니다.",
    "error_gif_too_large": "움직이는 사진(GIF)은 5MB까지 보낼 수 있습니다.",
    "error_unsupported_file_type": "지원하지 않는 파일 형식입니다.",
    "error_video_too_large": "영상 용량이 너무 커요. 더 짧게 촬영하거나 화질을 낮춰서 보내주세요",
    "error_video_too_long": "영상이 너무 길어요. 약 30초 이내로 짧게 잘라서 보내주세요",
    "error_unsupported_video": "지원하지 않거나 재생할 수 없는 동영상입니다.",
    "error_video_unsupported_format": "미리보기를 만들 수 없는 영상이에요. 클립 버튼으로 파일 첨부하면 상대방이 내려받아 볼 수 있어요",
    "warn_video_hevc": "이 동영상은 고효율(HEVC) 형식입니다. 상대방 기기에 따라 재생되지 않을 수 있습니다. 아이폰 설정 → 카메라 → 포맷에서 '높은 호환성'을 선택한 뒤 촬영하면 호환성이 높아집니다.",
    "video_thumb_fallback": "미리보기를 만들지 못했어요. 전송은 정상적으로 진행됩니다",
    "upload_failed": "전송 실패",
    "retry": "다시 시도",
    "delete": "삭제",
    "attachment_title": "파일 첨부",
    "attachment_photo": "사진",
    "attachment_file": "문서",
    "attachment_video": "동영상",
    "saving": "저장하고 있어요...",
    "saved": "저장했습니다.",
    "save_failed": "저장에 실패했습니다.",
    "attachment_expired": "보관 기간이 지난 파일입니다",
    "toast_attachment_guide": "삭제 혹은 저장 하시려면 길게 눌러 주세요",
    "expiry_until_date": "유효기간 ~{{date}}",
    "expiry_days_left": "{{days}}일 남음",
    "expiry_today": "오늘 만료",
    "attachment_image_alt": "첨부 이미지",
    "attachment_video_thumb_alt": "동영상 썸네일",
    "cancel_attachment": "첨부 취소"
  },
  "invite": {
    "share_sms": "MooWoo 채팅 초대: {{inviteLink}}",
    "share_email_subject": "MooWoo 채팅 초대",
    "share_email_body": "아래 링크로 채팅에 참여하세요:\n{{inviteLink}}",
    "title": "채팅에 초대하기",
    "description": "앱 설치 없이 브라우저에서 바로 참여할 수 있어요.",
    "copied": "복사됨!",
    "copy_link": "링크 복사",
    "share_message": "메시지",
    "share_email": "이메일",
    "share_qr": "QR 코드",
    "close": "닫기",
    "select_lang_placeholder": "초대할 분이 쓰는 언어를 골라주세요",
    "select_lang_guide": "상대가 처음 볼 언어예요. 나중에 바꿀 수 있어요",
    "err_select_lang_first": "처음 건넬 언어를 먼저 골라주세요",
    "link_placeholder": "언어를 고르면 링크가 만들어져요",
    "qr_title": "스캔하여 참여하기",
    "qr_desc": "카메라로 QR 코드를 비추면 채팅방이 열려요."
  },
  "friends_sheet": {
    "confirm_default": "확인",
    "cancel_default": "취소",
    "loading": "불러오는 중...",
    "blocked_title": "차단된 친구",
    "blocked_desc": "차단을 해제하면 다시 대화할 수 있어요",
    "blocked_empty": "차단한 친구가 없어요",
    "unblock_btn": "해제",
    "unblock_toast": "{{name}}님의 차단을 해제했어요",
    "deleted_title": "삭제된 친구",
    "deleted_desc": "복원하면 다시 대화하거나 친구로 추가할 수 있어요",
    "deleted_empty": "삭제된 친구가 없어요",
    "restore_btn": "복원",
    "restore_toast": "{{name}}님을 복원했어요",
    "restore_error": "복원 처리에 실패했어요. 다시 시도해 주세요."
  },
  "join_via_link": {
    "invited_title": "{{name}}님이 채팅에 초대했어요",
    "invited_desc": "각자 자기 언어로 대화하세요 — MooWoo가 양쪽 모두 자동 번역해드려요.",
    "join_button": "대화 참여하기",
    "invalid_link": "사용할 수 없는 링크예요",
    "go_home": "처음 화면으로",
    "email_label": "이메일 주소",
    "email_placeholder": "example@email.com",
    "email_invalid": "유효한 이메일 형식이 아닙니다.",
    "error_dead_link": "유효하지 않은 링크입니다.",
    "error_timeout": "인증 유효 시간이 초과되었습니다. 초대 링크를 다시 열어 시도해 주세요.",
    "error_failed": "처리 중 오류가 발생했습니다. 다시 시도해 주세요.",
    "footer_note1": "이메일 인증 한 번으로 바로 시작할 수 있어요.",
    "footer_note2": "대화 내용은 AI 학습에 사용되지 않아요.",
    "required": "*필수",
    "already_member": "이미 {{name}}님으로 로그인되어 있어요.",
    "continue_as_me": "이대로 대화 시작하기",
    "use_other_account": "다른 계정으로 시작하기",
    "self_invite": "내가 만든 초대 링크예요.",
    "google_login": "구글로 로그인",
    "email_required": "이메일 주소를 입력해 주세요.",
    "google_preparing": "곧 열립니다. 지금은 이메일로 들어와 주세요."
  },
  "friend_profile": {
    "page_title": "{{name}}의 프로필",
    "loading": "프로필을 불러오는 중...",
    "error_not_found": "프로필을 찾을 수 없습니다.",
    "save": "저장",
    "cancel": "취소",
    "nickname_save_failed": "저장에 실패했어요. 다시 시도해주세요.",
    "nickname_instruction": "수정하시려면 새로운 이름을 입력해 주세요.",
    "remove_nickname": "별명 지우기"
  },
  "moowoo": {
    "unit": "무우",
    "unitShort": "MW",
    "badgeAria": "내 무우 재고",
    "myBalance": "무우 재고",
    "availablePower": "사용 가능",
    "messagesLeft": "남은 메시지 약 {{count, moowoo}}개",
    "emptyHint": "메시지를 보내려면 무우가 필요해요",
    "noteLow": "무우가 얼마 남지 않았어요.",
    "noteCritical": "곧 메시지를 보낼 수 없어요.",
    "noteEmpty": "무우를 모두 사용했어요.",
    "expiresOn": "{{date}} 소멸 예정",
    "expires_item": "{{label}} {{amount}}{{unit}} · {{date}} 소멸",
    "label_free": "무료",
    "label_paid": "유료",
    "noteLowAction": "무우가 얼마 남지 않았어요. 충전해 두시면 대화가 끊기지 않아요.",
    "noteEmptyAction": "무우를 다 쓰셨어요. 충전하시면 다시 대화할 수 있어요.",
    "pageTitle": "무우",
    "back": "뒤로 가기",
    "topUp": "무우 가게",
    "packBenefit": "기본 톤 · 하루 30개씩 약 5개월",
    "packCaption": "쓴 만큼 조금씩 줄어들어요. 짧은 메시지 1건이 약 1무우, 정중·친근 톤은 조금 더 나가요.",
    "expiry": "충전일로부터 9개월 유효",
    "taxNote": "(부가세 포함)",
    "payButton": "무우 사러 가기",
    "comingSoon": "결제 기능은 준비 중입니다.",
    "gift": {
      "sheetTitle": "무우",
      "receivedFrom": "{{name}}님이 {{amount}} 무우를 보냈습니다",
      "receivedAtWithExpiry": "{{createdAt}} (수령 기한 {{expiresAt}})",
      "claim": "받기",
      "sendGift": "무우 보내기",
      "toName": "{{name}}님에게",
      "selectReceiver": "받는 사람 선택",
      "totalBalance": "전체 잔고 {{amount}} 무우",
      "sendable": "보낼 수 있는 무우 {{amount}} 무우",
      "balanceAfter": "보낸 후 잔고 {{from}} → {{to}} 무우",
      "cancel": "취소",
      "confirm": "확인",
      "errMinAmount": "1 무우 이상 입력해 주세요",
      "errInsufficient": "보낼 수 있는 무우를 초과했습니다",
      "errExceedsSendable": "보낼 수 있는 무우를 초과했습니다",
      "lockNoSendable": "보낼 수 있는 유료 무우가 없습니다",
      "lockPaidExpired": "유료 무우의 유효기간이 만료되었습니다",
      "sending": "전송 중...",
      "successMessage": "무우를 보냈습니다.",
      "errUnauthenticated": "로그인이 필요합니다.",
      "errInvalidAmount": "유효하지 않은 금액입니다.",
      "errSelfGift": "자신에게 무우를 보낼 수 없습니다.",
      "errNotParticipant": "대화 참여자가 아닙니다.",
      "errPaidExpired": "유효기간이 만료된 무우입니다.",
      "errInsufficientPaid": "보낼 수 있는 유료 무우가 부족합니다.",
      "errUnknown": "서버 통신 중 오류가 발생했습니다.",
      "claimSuccess": "무우를 받았습니다.",
      "errGiftNotFound": "무우를 찾을 수 없습니다.",
      "errNotRecipient": "받을 수 있는 대상이 아닙니다.",
      "errAlreadyClaimed": "이미 받은 무우입니다.",
      "errGiftExpired": "받을 수 있는 기간이 지났습니다.",
      "reject": "거절",
      "confirmReject": "정말 거절",
      "rejectSuccess": "무우를 사양했습니다.",
      "errRejectUnknown": "무우 사양에 실패했습니다.",
      "errAlreadyProcessed": "이미 처리된 무우입니다.",
      "processing": "처리 중...",
      "giftExpiredNotice": "기한이 지난 무우",
      "selectRecipientTitle": "무우 보낼 멤버 선택",
      "noMembersAvailable": "무우를 보낼 수 있는 멤버가 없습니다"
    },
    "history": {
      "pageTitle": "재고 내역",
      "empty": "아직 내역이 없어요",
      "emptyFiltered": "해당 유형의 내역이 없어요",
      "loading": "불러오는 중",
      "typeCharge": "무우 구매",
      "typeGrantFree": "무료 무우",
      "typeGiftIn": "받은 무우",
      "typeGiftRefundExpire": "미수취반환(만료)",
      "typeGiftRefundReject": "미수취반환(거절)",
      "typeRefund": "환불",
      "typeUse": "번역",
      "typeGiftOut": "보낸 무우",
      "typePeriodExpire": "기간만료",
      "typeExpire": "만료",
      "entry": "재고 내역 보기",
      "translationCount": "번역 {{count}}건",
      "itemCount": "{{count}}건",
      "loadNextChunk": "{{count}}건 더 보기",
      "loadNextChunk20": "20건씩 더 보기 ({{remain}})",
      "showInitialChunk": "처음 20건만 보기",
      "viewAllTotal": "전체 보기 ({{total}})",
      "viewAllLimitToast": "최대 200건까지만 조회 가능합니다",
      "unknownUser": "알 수 없음",
      "summaryReceived": "받은 무우",
      "summaryUsed": "쓴 무우",
      "summaryRemaining": "남은 무우",
      "summaryFreeLabel": "무료",
      "summaryPaidLabel": "구매",
      "expiresUntil": "({{date}}까지)"
    }
  },
  "checkout": {
    "title": "결제 확인",
    "orderSummary": "주문 내역",
    "total": "총 결제 금액",
    "priceNote": "표시 금액이 최종 결제액입니다",
    "termsAgree": "결제 및 환불 정책(1회 사용 시 환불 불가)에 동의합니다",
    "payWithCard": "카드 및 기타 결제",
    "payWithPayPal": "PayPal 로 결제",
    "linkTerms": "이용약관",
    "linkPrivacy": "개인정보처리방침",
    "linkTermsAria": "이용약관 열기",
    "linkPrivacyAria": "개인정보처리방침 열기",
    "termsModalTitle": "서비스 이용약관",
    "closeModal": "닫기",
    "guideTitle": "안내"
  },
  "paymentResult": {
    "title": "결제 결과",
    "successTitle": "결제가 완료되었습니다",
    "successDesc": "무우 충전이 정상적으로 처리되었습니다.\n이제 마음껏 서비스를 이용해 보세요!",
    "failTitle": "결제에 실패했습니다",
    "failDesc": "결제 처리 중 문제가 발생했습니다.\n잠시 후 다시 시도해 주세요.",
    "cancelTitle": "결제가 취소되었습니다",
    "cancelDesc": "결제 진행이 취소되었습니다.\n문제가 지속되면 고객센터로 문의해 주세요.",
    "btnMoowoo": "무우 가게로",
    "btnRetry": "다시 시도",
    "btnHome": "홈으로"
  },
  "common": {
    "install_guide_default": "위 '앱 다운로드' 버튼을 눌러주세요",
    "install_guide_ios": "하단 공유 버튼을 눌러 ‘홈 화면에 추가’를 선택해 주세요.",
    "install_guide_inapp": "이 화면에서는 바로 설치할 수 없어요. 위 '앱 다운로드'를 눌러 크롬으로 열어 주세요",
    "install_app_short": "앱 다운로드",
    "install_address_bar_hint": "브라우저 주소창 오른쪽의 설치 아이콘을 눌러 주세요. 아이콘이 보이지 않으면 시크릿 창에서는 설치할 수 없으니 일반 창에서 열어 주세요.",
    "close": "닫기",
    "logout": "로그아웃",
    "logging_out": "로그아웃 중…",
    "cancel": "취소",
    "confirm": "확인",
    "preview_sender_me": "나: ",
    "preview_photo": "사진",
    "preview_video": "동영상",
    "preview_file": "문서",
    "preview_no_messages": "대화 없음",
    "preview_invite_pending": "초대를 수락하면 볼 수 있어요",
    "preview_gift_sent_by_me": "무우를 보냈습니다",
    "preview_gift_received_by_me": "{{sender}}님이 무우를 보냈습니다",
    "preview_gift_sent_by_other": "{{sender}}님이 {{receiver}}님에게 무우를 보냈습니다",
    "preview_gift_sent_by_other_fallback": "{{sender}}님이 무우를 보냈습니다",
    "preview_gift_rejected": "{{sender}}님이 무우를 사양했습니다",
    "preview_gift_rejected_no_name": "무우를 사양했습니다",
    "preview_gift_claimed": "{{sender}}님이 무우를 받았습니다",
    "preview_gift_claimed_no_name": "무우를 받았습니다",
    "preview_gift_expired": "무우가 기한이 지나 반환되었습니다"
  },
  "video_viewer": {
    "loading": "영상을 불러오는 중...",
    "download_original": "원본 내려받기",
    "downloading": "내려받는 중...",
    "downloaded": "내려받기 완료",
    "download_failed": "내려받기 실패",
    "playback_failed_guide": "코덱이 맞지 않으면 재생이 안될 수도 있습니다. 그럴 땐 원본을 저장해 보세요.",
    "url_error": "영상을 불러올 수 없습니다. 원본을 내려받아 확인해 보세요.",
    "default_title": "동영상",
    "default_filename": "동영상.mp4"
  },
  "group_info": {
    "title": "대화방 정보",
    "members_title": "대화 상대 ({{count}})",
    "pending_members_title": "초대중 ({{count}})",
    "leave_button": "대화방 나가기",
    "owner_badge": "방장",
    "me_badge": "나",
    "leave_confirm_title": "대화방 나가기",
    "leave_confirm_desc": "대화방을 나가면 대화 목록에서 사라지고, 다시 초대받아야 참여할 수 있습니다.",
    "leave_confirm_btn": "나가기",
    "leave_cancel_btn": "취소",
    "leave_success_toast": "대화방을 나갔습니다.",
    "leave_error_toast": "대화방 나가기 중 오류가 발생했습니다.",
    "invite_button": "초대"
  },
  "group_invite": {
    "title": "대화 상대 초대",
    "count_display": "{{count}}/10",
    "count_subtext": "초대 대기중 인원 포함",
    "search_placeholder": "이름 검색",
    "invite_btn": "초대하기",
    "invite_btn_with_count": "초대하기 ({{count}})",
    "no_candidates": "초대 가능한 대화 상대가 없습니다.",
    "err_room_full_limit": "최대 10명까지만 초대할 수 있습니다.",
    "invite_success": "{{count}}명을 초대했습니다.",
    "err_room_full": "대화방 정원(10명)을 초과했습니다.",
    "err_already_member": "이미 대화방에 참여 중인 멤버입니다.",
    "err_kicked_owner_only": "강퇴된 멤버는 방장만 다시 초대할 수 있습니다.",
    "err_no_direct_history": "1:1 대화 이력이 있는 친구만 초대할 수 있습니다.",
    "err_no_permission": "대화방에 참여 중인 멤버만 초대할 수 있습니다.",
    "err_unauthenticated": "로그인이 필요합니다.",
    "err_not_active": "대화방 참여 상태가 아닙니다.",
    "err_no_targets": "초대할 대상을 선택해 주세요.",
    "err_general": "초대 처리 중 오류가 발생했습니다."
  },
  "system_message": {
    "invited_single": "{{actor}}님이 {{target}}님을 초대했습니다",
    "invited_multiple": "{{actor}}님이 {{target}}님 외 {{count}}명을 초대했습니다",
    "joined": "{{actor}}님이 들어왔습니다",
    "left": "{{actor}}님이 나갔습니다",
    "gift_sent": "{{sender}}님이 {{receiver}}님에게 무우를 보냈습니다",
    "gift_rejected": "{{name}}님이 무우를 사양했습니다",
    "gift_claimed": "{{name}}님이 무우를 받았습니다",
    "gift_expired_to_sender": "{{name}}님에게 보낸 무우가 기한이 지나 반환되었습니다",
    "gift_expired_to_receiver": "{{name}}님이 보낸 무우가 기한이 지나 반환되었습니다",
    "unknown_user": "알 수 없는 사용자"
  },
  "notification": {
    "group_invite_received": "{{name}}님이 초대했습니다",
    "group_invite_received_anonymous": "새 초대가 도착했습니다",
    "group_invite_received_group": "{{name}}님이 단체방에 초대했습니다",
    "group_invite_received_direct": "{{name}}님이 1:1 채팅에 초대했습니다",
    "moowoo_gift_expired": "무우 {{amount}}개가 반환되었습니다",
    "moowoo_gift_rejected": "{{name}}님이 무우를 사양했습니다",
    "moowoo_gift_rejected_more": "{{name}}님이 무우를 사양했습니다 (외 {{count}}건)",
    "unnamed_room": "이름 없는 단체방",
    "close": "닫기",
    "group_invite_accepted": "{{name}}님이 초대를 수락했습니다",
    "group_invite_rejected": "{{name}}님이 초대를 거절했습니다",
    "friend_request_received": "{{name}}님이 친구 요청을 보냈어요",
    "friend_request_accepted": "{{name}}님과 친구가 되었어요. 대화를 시작해 보세요",
    "friend_request_rejected": "요청이 마감되었어요. 친구 찾기에서 다시 보낼 수 있어요",
    "friend_accept": "수락",
    "friend_reject": "거절",
    "friend_accepted": "친구가 되었어요",
    "friend_rejected": "요청을 거절했어요",
    "friend_state_accepted": "수락됨",
    "friend_state_rejected": "거절됨",
    "friend_state_handled": "처리됨",
    "friend_already_handled": "이미 처리된 요청이에요",
    "friend_action_error": "처리에 실패했어요. 잠시 후 다시 시도해 주세요"
  },
  "avatar_cropper": {
    "title_avatar": "아바타 영역 선택",
    "title_photo": "사진 영역 선택",
    "cancel": "취소",
    "reset": "원래대로",
    "save": "저장",
    "saving": "저장 중...",
    "unsupported_format": "지원하지 않는 이미지 형식입니다",
    "process_error": "이미지 처리 중 오류가 발생했습니다."
  },
  "avatar_picker": {
    "title": "아바타 선택",
    "tab_dog": "강아지",
    "tab_man": "남성",
    "tab_woman": "여성",
    "tab_photo": "내 사진",
    "select_photo": "사진 선택",
    "change_photo": "다른 사진으로 바꾸기",
    "confirm_title": "이 아바타로 할까요?",
    "cancel": "취소",
    "save": "저장",
    "save_success": "저장되었습니다",
    "back_aria": "뒤로가기",
    "err_size": "사진이 너무 큽니다. 30MB 이하로 올려주세요.",
    "err_format": "이 형식은 지원하지 않습니다. JPG, PNG, WebP 사진을 올려주세요.",
    "err_save": "저장하지 못했습니다. 잠시 후 다시 시도해주세요."
  },
  "temp_profile_banner": {
    "message": "이름과 아바타가 임시로 설정되어 있어요.",
    "action": "프로필에서 변경하기",
    "close_aria": "배너 닫기"
  },
  "push_prompt_banner": {
    "title": "알림을 켜면 메시지와 전화를 놓치지 않아요",
    "desc": "앱을 닫아도 새 소식을 바로 알려드려요.",
    "btn_enable": "알림 켜기",
    "btn_later": "나중에",
    "close_aria": "알림 안내 닫기",
    "toast_success": "알림을 켰어요.",
    "toast_denied": "브라우저에서 알림이 차단되어 있어요. 브라우저 설정에서 허용해 주세요.",
    "toast_default": "알림 허용 창이 나타나지 않았습니다. 주소창의 자물쇠 아이콘을 눌러 알림을 '허용'으로 바꿔 주세요.",
    "toast_sw_timeout": "알림 준비가 지연되고 있습니다. 잠시 후 다시 시도해 주세요.",
    "toast_failed": "알림을 켜지 못했어요. 잠시 후 다시 시도해 주세요."
  },
  "settings": {
    "title": "설정",
    "back_aria": "뒤로가기",
    "section_notifications": "알림",
    "push_message": "메시지",
    "push_invite": "대화방 초대",
    "push_gift": "무우 선물",
    "save_error": "설정을 저장하지 못했습니다. 잠시 후 다시 시도해주세요.",
    "allow_notifications": "알림 허용",
    "unsupported_push": "현재 브라우저에서는 웹 푸시 알림을 지원하지 않습니다.",
    "blocked_push": "알림이 차단되어 있습니다. 주소창 왼쪽 아이콘을 눌러 '권한' 또는 '사이트 설정'에서 알림을 허용해 주세요.",
    "blocked_push_toast": "브라우저가 알림을 차단한 상태입니다. 주소창의 자물쇠 아이콘을 눌러 알림을 '허용'으로 바꿔 주세요.",
    "error_permission_denied": "알림 권한이 허용되지 않았습니다.",
    "error_sw_timeout": "알림 준비가 지연되고 있습니다. 잠시 후 다시 시도해 주세요.",
    "error_subscribe_failed": "알림 구독에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    "error_unsubscribe_failed": "알림 구독 해제에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    "error_vapid_missing": "푸시 설정 키(VAPID)를 찾을 수 없습니다.",
    "ios_homescreen_guide": "알림을 받으려면 홈 화면에 추가해 주세요. 사파리 아래쪽의 공유 버튼을 누른 뒤 '홈 화면에 추가'를 선택하시면 됩니다.",
    "notif_guide_title": "알림이 안 오거나 소리만 나나요?",
    "notif_guide_android_popup_title": "소리는 나는데 화면 위로 안 내려올 때",
    "notif_guide_android_missing_title": "알림이 아예 안 올 때",
    "notif_guide_android_pwa_popup": "휴대폰 설정 → 애플리케이션 → MooWoo → 알림 → 알림 카테고리 → 일반 → '팝업으로 표시'를 켜 주세요.",
    "notif_guide_android_pwa_category": "'알림 카테고리'가 안 보이면 설정 → 알림 → 고급 설정 → '앱별 알림 카테고리 관리'를 먼저 켜 주세요.",
    "notif_guide_android_pwa_missing": "같은 MooWoo 알림 화면에서 '알림 허용'을 켜고, 배터리 절약 기능을 꺼 주세요.",
    "notif_guide_android_browser_popup": "휴대폰 설정 → 알림 → 앱 알림 → {{browser}} → chat.moowoo.app 에서 '팝업으로 표시'를 켜 주세요.",
    "notif_guide_android_browser_missing": "같은 화면에서 chat.moowoo.app 알림을 허용하고, 배터리 절약 기능을 꺼 주세요.",
    "notif_guide_android_note": "※ 메뉴 이름은 휴대폰 기종마다 조금 다를 수 있어요.",
    "notif_guide_windows": "알림이 오지 않으면 윈도우 설정에서 {{browser}} 알림을 켜 주세요. 집중 모드(방해 금지 모드)가 켜져 있으면 꺼 주세요.",
    "notif_guide_mac": "알림이 오지 않으면 시스템 설정에서 {{browser}} 알림을 켜 주세요. 집중 모드(방해 금지 모드)가 켜져 있으면 꺼 주세요.",
    "notif_test_label": "알림 테스트",
    "notif_test_button": "보내기",
    "notif_test_sending": "보내는 중",
    "notif_test_title": "무우",
    "notif_test_body": "알림이 정상적으로 도착했습니다.",
    "notif_test_sent": "테스트 알림을 보냈습니다. 잠시 후 알림이 오는지 확인해 주세요.",
    "notif_test_failed": "테스트 알림 발송에 실패했습니다. 잠시 후 다시 시도해 주세요.",
    "browser_samsung": "삼성 인터넷",
    "browser_whale": "웨일",
    "browser_edge": "엣지",
    "browser_opera": "오페라",
    "browser_firefox": "파이어폭스",
    "browser_chrome": "크롬",
    "browser_safari": "사파리",
    "browser_generic": "브라우저",
    "inapp_guide_android": "인앱 브라우저에서는 알림을 켤 수 없습니다. 외부 Chrome 브라우저로 전환해 주세요.",
    "inapp_guide_android_failed": "Chrome 브라우저를 열지 못했습니다. 주소를 복사하여 Chrome 주소창에 붙여넣어 주세요.",
    "inapp_guide_ios": "인앱 브라우저에서는 알림을 켤 수 없습니다. 주소를 복사한 뒤 Safari 주소창에 붙여넣어 주세요.",
    "inapp_guide_generic": "인앱 브라우저에서는 알림을 켤 수 없습니다. 외부 브라우저에서 이용해 주세요.",
    "inapp_btn_open_chrome": "Chrome 브라우저로 열기",
    "inapp_btn_copy_url": "주소 복사",
    "inapp_copy_success": "주소가 복사되었습니다. 외부 브라우저 주소창에 붙여넣어 주세요.",
    "inapp_copy_failed": "주소 복사에 실패했습니다. 아래 주소를 직접 길게 눌러 복사해 주세요.",
    "inapp_copy_manual_guide": "아래 주소를 길게 눌러 전체 복사해 주세요:",
    "inapp_open_failed_toast": "외부 브라우저를 열지 못했습니다. 주소를 복사해 주세요.",
    "section_legal": "약관 및 정책",
    "privacy_policy": "개인정보처리방침",
    "terms_of_service": "이용약관"
  },
  "legal": {
    "privacy_title": "개인정보처리방침",
    "terms_title": "서비스 이용약관"
  },
  "notification_box": {
    "title": "알림 보관함",
    "empty": "받은 알림이 없습니다.",
    "empty_desc": "최근 30일 동안 도착한 알림이 여기에 보관됩니다.",
    "back_aria": "뒤로가기",
    "bell_aria": "알림 보관함",
    "mark_all_read": "모두 읽음",
    "mark_all_read_aria": "모든 알림 읽음 처리",
    "unread_badge_aria": "미확인 알림 {{count}}개"
  },
  "notification": {
    "moowoo_gift_expired": "{{amount}} 무우 선물의 수령 기한이 지났어요",
    "moowoo_gift_rejected": "{{name}}님이 무우 선물을 사양했어요",
    "group_invite_received_group": "{{name}}님이 그룹 대화방에 초대했어요",
    "group_invite_received_direct": "{{name}}님이 1:1 대화방에 초대했어요",
    "group_invite_received_anonymous": "새로운 대화방에 초대받았어요",
    "group_invite_accepted": "{{name}}님이 초대를 수락했어요",
    "group_invite_rejected": "{{name}}님이 초대를 거절했어요",
    "friend_request_received": "{{name}}님이 친구 요청을 보냈어요",
    "friend_request_accepted": "{{name}}님과 친구가 되었어요. 대화를 시작해 보세요",
    "friend_request_rejected": "요청이 마감되었어요. 친구 찾기에서 다시 보낼 수 있어요",
    "friend_state_accepted": "수락했어요",
    "friend_state_rejected": "거절했어요",
    "friend_state_handled": "처리했어요",
    "friend_accept": "수락",
    "friend_reject": "거절",
    "friend_already_handled": "이미 처리된 친구 요청이에요",
    "friend_action_error": "처리에 실패했어요. 잠시 후 다시 시도해 주세요",
    "friend_accepted": "친구 요청을 수락했어요",
    "friend_rejected": "친구 요청을 거절했어요",
    "friend_fetch_retry_hint": "친구 요청 정보를 불러오지 못했어요. 잠시 후 다시 시도해 주세요",
    "unknown_user": "알 수 없음",
    "close": "닫기",
    "edit": "편집",
    "cancel": "취소",
    "select_all": "전체 선택",
    "deselect_all": "전체 해제",
    "selected_count": "{{count}}개 선택됨",
    "action_delete": "삭제",
    "delete_confirm_title": "알림 삭제",
    "delete_confirm_desc": "선택한 {{count}}개의 알림을 삭제할까요?\n삭제된 알림은 다시 복구할 수 없어요.",
    "delete_success": "알림을 삭제했어요",
    "delete_error": "알림 삭제에 실패했어요. 잠시 후 다시 시도해 주세요",
    "cannot_delete_pending_friend": "대기 중인 친구 요청은 먼저 수락하거나 거절해 주세요"
  },
  "call": {
    "group_call_title": "단체 음성 통화",
    "group_incoming": "단체 음성 통화가 왔어요",
    "group_call_title_video": "단체 영상 통화",
    "group_incoming_video": "단체 영상 통화가 왔어요",
    "group_waiting": "다른 분들을 기다리는 중…",
    "group_connecting": "연결하는 중…",
    "group_participants": "{{count}}명 참여 중",
    "group_call_in_progress": "단체 음성 통화 진행 중",
    "group_call_in_progress_video": "단체 영상 통화 진행 중",
    "back_to_grid": "격자로 돌아가기",
    "group_double_tap_hint": "두 번 탭하면 크게 볼 수 있어요",
    "group_join": "참여",
    "group_call_full": "통화 인원이 가득 찼어요",
    "group_me": "나",
    "group_peer_connecting": "연결 중",
    "group_peer_joined": "{{name}}님이 들어왔어요",
    "group_peer_left": "{{name}}님이 나갔어요",
    "group_peer_lost": "{{name}}님 연결이 끊겼어요",
    "group_peers_left": "{{name}}님 외 {{count}}명이 나갔어요",
    "group_alone_countdown": "모두 나갔어요 · {{seconds}}초 뒤 통화가 끝나요",
    "group_no_answer": "받는 사람이 없어요",
    "group_ended_alone": "모두 나가서 통화가 끝났어요",
    "group_left_while_away": "연결이 끊겨 통화에서 나왔어요",
    "group_cancelled": "건 사람이 통화를 취소했어요",
    "group_unstable": "인터넷 연결이 불안정해요",
    "tap_to_unmute": "눌러서 소리 켜기",
    "minimize": "작게 보기",
    "expand": "크게 보기",
    "unavailable_partner": "통화할 수 없는 상대입니다.",
    "mic_permission_denied": "마이크 권한이 필요합니다. 브라우저 설정에서 마이크를 허용해 주세요.",
    "calling": "연결 중...",
    "incoming": "음성 통화 요청",
    "incoming_video": "화상 통화 요청",
    "connected": "통화 중",
    "in_progress": "통화 중입니다.\n한 번 더 누르면\n통화가 끊길 수 있어요",
    "ended": "통화가 종료되었습니다.",
    "accept": "받기",
    "accept_voice": "음성으로 받기",
    "accept_video": "화상으로 받기",
    "decline": "거절",
    "end": "종료",
    "failed": "통화 연결에 실패했습니다.",
    "connection_failed": "통화 연결에 실패했습니다.",
    "connection_lost": "네트워크 연결이 끊겨 통화가 종료되었습니다.",
    "no_answer": "응답이 없습니다.",
    "busy": "상대가 통화 중입니다.",
    "declined": "상대가 통화를 거절했습니다.",
    "canceled": "통화가 취소되었습니다.",
    "already_ended": "이미 종료된 통화입니다.",
    "recovery_failed": "통화 연결 정보를 가져오지 못했습니다.",
    "preparing_connection": "연결 준비 중",
    "log_missed": "부재중 통화",
    "log_canceled": "취소한 통화",
    "log_no_answer": "응답 없음",
    "log_declined": "통화 거절됨",
    "log_busy": "통화 중으로 연결 안 됨",
    "log_failed": "연결 실패",
    "log_ended": "음성 통화 {{duration}}",
    "log_ended_video": "화상 통화 {{duration}}",
    "blocked_attempt": "차단한 상대의 통화 시도",
    "mute": "음소거",
    "speaker": "스피커",
    "earphones": "이어폰 연결",
    "video": "화상",
    "translate": "통역",
    "peer_muted": "상대방이 음소거 중입니다",
    "muted_indicator": "음소거 중",
    "feature_in_verification": "기능 검증중입니다.",
    "device_reconnected": "오디오 장치를 다시 연결했습니다",
    "device_reconnect_failed": "오디오 장치 재연결 실패",
    "speaker_switched_named": "출력 장치: {{device}}",
    "speaker_switched": "출력 장치를 전환했습니다.",
    "speaker_switch_failed": "출력 장치를 전환할 수 없습니다.",
    "speaker_not_supported": "이 브라우저에서는 앱 내 스피커 전환을 지원하지 않습니다. 기기의 볼륨 버튼이나 이어폰 연결로 조절해 주세요.",
    "mic_locked_banner": "마이크가 잠겨 있습니다. 키를 눌러(Fn+F8 등) 해제해 주세요",
    "mic_locked_help_btn": "해결 방법",
    "mic_guide_title": "마이크 잠김 해결 방법",
    "mic_guide_close_aria": "닫기",
    "mic_guide_step1": "키보드의 마이크 모양 키를 눌러 주세요 (Fn+F8, Fn+F4 등 기종마다 다릅니다)",
    "mic_guide_step2": "화면 우측 하단 스피커 아이콘 우클릭 → 소리 설정 → 입력 → 마이크 음소거 해제",
    "mic_guide_step3": "주소창 왼쪽 자물쇠 아이콘 → 마이크 권한이 '허용'인지 확인",
    "mic_guide_step4": "그래도 안 되면 통화를 종료하고 다시 연결해 주세요",
    "mic_guide_close_btn": "닫기",
    "mic_reconnected_named": "마이크를 다시 연결했어요: {{name}}",
    "mic_changed_named": "마이크가 바뀌었어요: {{name}}",
    "mic_changed": "마이크가 바뀌었어요",
    "redial_title": "음성 통화",
    "redial_video_title": "화상 통화",
    "redial_confirm": "{{name}}님에게 다시 연결할까요?",
    "redial_connect": "연결",
    "camera_permission_denied": "카메라 권한이 꺼져 있어요. 휴대폰 설정에서 카메라를 허용해 주세요.",
    "camera_permission_denied_desktop": "카메라 권한이 꺼져 있어요.\n주소창 왼쪽 아이콘을 눌러 카메라를 '허용'으로 바꿔 주세요.",
    "camera_unavailable": "카메라를 켤 수 없어요. 다른 앱이 쓰고 있는지 확인해 주세요.",
    "camera_no_picture": "카메라 화면이 나오지 않아요.\n카메라 덮개(가림막)를 확인하고, 카메라 버튼을 껐다 다시 켜 주세요.",
    "camera_no_picture_chrome": "카메라 화면이 나오지 않아요.\n① 카메라 덮개(가림막)가 닫혀 있는지 확인해 주세요.\n② 그래도 안 되면 크롬 설정 → 개인 정보 보호 및 보안 → 사이트 설정 → 카메라에서 다른 카메라를 골라 주세요.",
    "camera_no_picture_edge": "카메라 화면이 나오지 않아요.\n① 카메라 덮개(가림막)가 닫혀 있는지 확인해 주세요.\n② 그래도 안 되면 엣지 설정 → 쿠키 및 사이트 권한 → 카메라에서 다른 카메라를 골라 주세요.",
    "camera_switched": "카메라 화면이 안 나와서 '{{name}}'(으)로 바꿨어요.\n다음 통화부터도 이 카메라를 먼저 써요.",
    "camera_another": "다른 카메라",
    "camera_not_ready": "카메라를 준비하고 있어요. 잠시 뒤 다시 눌러 주세요.",
    "peer_video_unsupported": "상대방 앱이 예전 버전이라 화상 통화를 할 수 없어요.\n상대방에게 앱을 완전히 닫았다가 다시 열어 달라고 알려 주세요.",
    "camera_switch_facing": "카메라 전환",
    "camera_switch_failed": "카메라를 바꾸지 못해서 원래 카메라로 돌아왔어요.",
    "camera_switch_lost": "카메라를 바꾸지 못해서 카메라를 껐어요.\n화상 버튼을 다시 눌러 주세요.",
    "camera_switch_reconnecting": "다시 연결 중이에요. 잠시 후 다시 시도해 주세요.",
    "peer_recovering": "상대가 다시 연결 중이에요 ({{seconds}}초)",
    "peer_recover_failed": "상대와 연결되지 않았어요. 다시 걸어 주세요.",
    "unstable_ended": "연결이 불안정해 통화가 끊겼어요. 다시 걸어 주세요.",
    "self_recovering": "연결을 다시 잡는 중이에요…",
    "net_changed_self": "인터넷 연결이 바뀌었어요. 통화를 다시 연결하는 중이에요. 끊지 말고 잠시만 기다려 주세요.",
    "net_changed_peer": "상대방 인터넷 연결이 바뀌었어요. 다시 연결하는 중이니 끊지 말고 잠시만 기다려 주세요.",
    "peer_unstable": "상대방 연결이 잠시 불안정해요. 끊지 말고 잠시만 기다려 주세요.",
    "reconnected": "다시 연결됐어요.",
    "rotate_screen": "화면 회전",
    "rotate_guide": "폰을 가로로 눕혀 보세요.\n화면이 안 돌면 빠른 설정에서\n'자동 회전'을 켜 주세요",
    "rotate_unsupported": "이 기기에서는\n화면 회전을 쓸 수 없어요"
  },
  "alert_modal": {
    "confirm": "확인"
  },
  "attachment_sheet": {
    "close_sheet": "첨부 시트 닫기"
  },
  "error_boundary": {
    "title": "일시적인 문제가 발생했습니다.",
    "desc": "잠시 후 다시 시도해 주세요.",
    "refresh": "새로고침"
  },
  "gift_sheet": {
    "close_sheet": "무우 시트 닫기"
  },
  "image_viewer": {
    "default_alt": "사진",
    "original_alt": "원본 사진",
    "default_filename": "사진.jpg"
  },
  "read_indicator": {
    "read": "읽음",
    "unread": "안 읽음"
  },
  "group_chat_list": {
    "default_group_name": "단체 대화방"
  },
  "new_group_chat": {
    "back_aria": "뒤로가기",
    "deselect_member_aria": "선택 해제"
  },
  "message_preview": {
    "gift_sent": "무우를 보냈습니다",
    "gift_rejected": "무우를 사양했습니다",
    "gift_received": "무우를 받았습니다",
    "gift_expired": "무우가 기한이 지나 반환되었습니다",
    "sender_me": "나: "
  },
  "upload_file": {
    "presign_failed": "사전 서명 URL 발급에 실패했습니다.",
    "download_url_failed": "다운로드 URL 발급에 실패했습니다."
  },
  "profile_media": {
    "invalid_photo_slot": "올바르지 않은 사진 위치입니다.",
    "login_required": "로그인이 필요합니다.",
    "photo_upload_failed": "사진 업로드에 실패했습니다.",
    "fetch_profile_failed": "프로필 정보를 불러오는데 실패했습니다.",
    "photo_save_failed": "사진 저장에 실패했습니다.",
    "photo_delete_failed": "사진 삭제에 실패했습니다.",
    "image_files_only": "이미지 파일만 올릴 수 있습니다",
    "image_too_large": "이미지 용량이 너무 큽니다",
    "avatar_upload_failed": "아바타 업로드에 실패했습니다.",
    "avatar_save_failed": "아바타 저장에 실패했습니다."
  }
}


